module.exports = __webpack_public_path__ + "img/emoji-61.8e1b68fe.png";